// extracted by mini-css-extract-plugin
module.exports = {"container":"_0fce717cdb--container--MknCw","container--size-m":"_0fce717cdb--container--size-m--X9dbp"};